<template>
    <!-- ref="bannerContainer" -->
    <div class="ui-newHome-banner">

        <!-- <div
            :style="[{position:'relative'},{backgroundColor:bannerBgColor}]"
            :class="[isOpenActivity?'newHome-bg-content':'newHome-bg-noActivity']"
        >
            <div v-if="isOpenActivity">
                <img
                    class="newhome-img-hidden"
                    :src="lowQualityImg(ActivityBannerObj.image)"
                />
                <KPL
                    class="ui-kpl-bg"
                    :url="ActivityBannerObj.url"
                    :clstag="'jr|keycount|8530052_index_topbanner_big_'+ newIndex+'|'+title"
                    eventId="MInterestFree_TopBanner"
                    :eventParam="'banner_bg_'+String(newIndex)"
                    @upData='bannerUpData(newBannerUpdata)'
                >
                    <img
                        class="newhome-img"
                        :src="lowQualityImg(ActivityBannerObj.image)"
                    />
                </KPL>
            </div>
            <div
                v-else
                class="newHome-bg"
            >
            </div>
            <div
                :class="[isOpenActivity?'ui-banner':'bannerNoActivity']"
                ref="bannera"
                v-if="newList && newList.length"
            >

                <div class="ui-home-f">

                    <Slider
                        class="act-slide1"
                        style="z-index:999;"
                        :autoPlay="isLoop"
                        :loop="isLoop"
                        :data="newList"
                        :speed="600"
                        :showDots="true"
                        :slideDots="newList"
                        @scrollEnd="onScrollEnd"
                        ref="mychild"
                    >
                        <div
                            class="ui-kpl"
                            style="height: 100%!important;"
                            v-for="(item, index) in newList"
                            :key="index"
                            :clstag="'jr|keycount|8530052_index_topbanner_small_'+ index+'|'+item.title"
                            @click='silderUpData(item)'
                        >
                            <div class="marTop"></div>
                            <a
                                href="javascript:void(0);"
                                class="act-banner1-wrap"
                            >
                                <img
                                    class="act-banner1"
                                    :src="lowQualityImg(item.image)"
                                    v-if="item.image"
                                >
                                <div class="ui-maskDiv"></div>
                            </a>
                        </div>
                    </Slider>
                </div>
            </div>
        </div> -->
        <!-- 背景图 -->
        <div class="store_home_banner">
            <div>
                <img
                    :src="isOpenActivity?ActivityBannerObj.image:''"
                    alt=""
                    class="store_banner_ActivityBg"
                    @click="jumpActivity"
                    clstag=" jr|keycount|jingxuan|act_banner_num0"
                    v-if="isOpenActivity"
                >
                <img
                    v-else
                    src="https://img12.360buyimg.com/jrpmobile/jfs/t1/98189/12/201/8589/5da92025E4ef5a197/b09eaa1b0c743e22.png"
                    class="store_banner_bg"
                >
            </div>
            <div
                ref="bannera"
                v-if="newList && newList.length"
                :class="[
            'store_banner_slider',isOpenActivity?'store_banner_swiperActivity':'store_banner_swiperNo']"
            >

                <Slider
                    style="z-index:999;"
                    :autoPlay="isLoop"
                    :loop="isLoop"
                    :data="newList"
                    :speed="600"
                    :showDots="true"
                    :slideDots="newList"
                    @scrollEnd="onScrollEnd"
                    ref="mychild"
                >
                    <div
                        class="ui-kpl"
                        style="height: 100%!important;"
                        v-for="(item, index) in newList"
                        :key="index"
                        :clstag="'jr|keycount|8530052_index_topbanner_small_'+ index+'|'+item.title"
                        @click='silderUpData(item)'
                    >
                        <!-- <div class="marTop"></div> -->
                        <a
                            href="javascript:void(0);"
                            class="act-banner1-wrap"
                        >
                            <img
                                class="act-banner1"
                                :src="item.image"
                                v-if="item.image"
                            >
                            <div
                                class="store_banner_swiper_adv"
                                v-if="item.showurl || item.clickurl"
                            >
                                <img src="https://img12.360buyimg.com/jrpmobile/jfs/t1/57399/38/13715/2641/5da9232eEaa79082e/6940ab9239c5c4d0.png">
                            </div>
                            <div class="ui-maskDiv"></div>
                        </a>
                    </div>
                </Slider>
                <!-- </div> -->
            </div>
        </div>

        <!-- 氛围icon -->
        <div>
            <div
                class="ui-home-banner"
                v-if="IconListLength==5"
            >
                <div
                    class="ui-flex"
                    v-for="(item,index) in IconList"
                    :key="index"
                    @click="showRedTip(item)"
                >
                    <NativeOpenWeb
                        :clstag="item.clstag"
                        :url="item.url"
                        :eventId="'MInterestFree_'+item.labeldes"
                        :eventParam="'1'"
                        :jumpType="item.sdk=='1'?'12':'8'"
                    >
                        <div :class="{'redPackWrap':item.labeldes=='免息红包' && isDue}">
                            <img :src="item.image" />
                            <div
                                v-if="item.highlight=='免息红包' && isDue"
                                class="ui-redtip"
                            ></div>
                        </div>
                        <p class="ui-text">{{item.labeldes}}</p>

                    </NativeOpenWeb>
                </div>
            </div>
            <div
                v-if="IconListLength==10"
                class="icon_wrap"
            >
                <div
                    class="ui-home-banner10"
                    v-for="(list,index) in IconList"
                    :key="index"
                >
                    <div
                        class="ui-flex"
                        v-for="(item,index) in list"
                        :key="index"
                        @click="showRedTip(item)"
                    >
                        <NativeOpenWeb
                            :clstag="item.clstag"
                            :url="item.url"
                            :eventId="'MInterestFree_'+item.labeldes"
                            :eventParam="'1'"
                            :jumpType="item.sdk=='1'?'12':'8'"
                        >
                            <div :class="{'redPackWrap':item.labeldes=='免息红包' && isDue}">
                                <img :src="item.image" />
                                <div
                                    v-if="item.labeldes=='免息红包' && isDue"
                                    class="ui-redtip"
                                ></div>
                            </div>
                            <p class="ui-text">{{item.labeldes}}</p>
                        </NativeOpenWeb>
                    </div>
                </div>
            </div>
        </div>
        <div id="clickLaiKeData"></div>
    </div>
</template>
<script>
import Slider from '@/components/Slider.vue';
import KPL from '@/buscomponents/KPL.vue';
import NativeOpenWeb from '@/buscomponents/NativeOpenWeb.vue';
import { isTimeOverdue, setTimeOverdue } from '@/util/storageDateLimt';
// import request from '@/util/request';
import { getStaticConfig, isMiniProgram, isEmptyObj, lowQualityImg } from '@/util/common';
import { GetSever } from '@/util/sqRequestService';
let settime = null;
let isDevelop = true;
let smallBannerPositionCode = 'mxxqsy.index.banner';
let bannerBgPositionCode = 'mxxqsy.index.bg';
switch (process.env.VUE_APP_ENV) {
    // case 'dev':
    case 'minner':
        isDevelop = false;
        smallBannerPositionCode = 'mxxqpre.index.banner';
        bannerBgPositionCode = 'mxxqpre.index.bg';
        break;
    case 'dev':
        isDevelop = false;
        smallBannerPositionCode = 'mxxqpre.index.banner';
        bannerBgPositionCode = 'mxxqpre.index.bg';
        break;
    default:
        isDevelop = true;
        smallBannerPositionCode = 'mxxqsy.index.banner';
        bannerBgPositionCode = 'mxxqsy.index.bg';
        break;
}
export default {
    name: 'Banner',
    components: {
        Slider,
        KPL,
        NativeOpenWeb
    },
    data() {
        return {
            newList: [],
            IconList: [],
            lowQualityImg: lowQualityImg,
            IconListLength: 0,
            bannerColor: '#fff',
            jdUrl: `https://bt.jd.com/v3/mobile/rGuide_initGuideMobileWXQQ?source=JD_xcx&channelName=194&returnUrl=${encodeURIComponent(window.location.origin + window.location.pathname)}`,
            newHomeBg: '',
            newUrl: '',
            title: '',
            newIndex: 0,
            // showBgBanner: false,
            isDue: true,
            vowLink: {},
            hasVowLink: false,
            newBannerUpdata: {}, //数据上报
            // hasOpenLaiKe: false, //是否关闭来客接口
            HomeBannerHeight: 0,
            bannerBgColor: '#000',
            isOpenActivity: false,
            ActivityBannerObj: {}
        };
    },
    props: {
        // list: {
        //     type: Array,
        //     default: () => {
        //         return [];
        //     }
        // },
        isLoop: {
            type: Boolean,
            default: true
        }
        // isOpenActivity: false,
        // ActivityBannerObj: {}
        // bannerBgColor: {
        //     type: String,
        //     default: '#000'
        // }
    },
    computed: {
        bannerFadeIn() {
            return 'bannerFadeIn';
        }
    },
    created() {
        // this.hasOpenLaiKe = getStaticConfig('hasOpenLaiKe');
        //获取氛围icon
        this.getIconList();
        //获取banner背景图活动信息
        this.bannerBgInfor();
        //获取首页小banner数组
        if ($.device && $.device.jdjr) {
            settime = setTimeout(() => {
                this.$nextTick(() => {
                    clearTimeout(settime);
                    this.getbannerList();
                });
            }, 300);
        } else {
            this.getLaikeBannerData();
        }
    },
    methods: {
        jumpActivity() {
            debugger;
            if (this.ActivityBannerObj && this.ActivityBannerObj.url) {
                window.location.href = this.ActivityBannerObj.url;
            }
        },
        getIconList() {
            let param = {};
            let taoShaMXX = 'mxxqsy';
            if (isDevelop) {
                taoShaMXX = 'mxxqsy';
            } else {
                taoShaMXX = 'mxxqpre';
            }
            if ($.device && $.device.jdapp) {
                //京东环境
                param.positionCode = `${taoShaMXX}.index.jdIcon`;
            } else if ($.device && $.device.jdjr) {
                //金融
                param.positionCode = `${taoShaMXX}.index.jrIcon`;
            } else if (isMiniProgram()) {
                //小程序
                param.positionCode = `${taoShaMXX}.index.spIcon`;
            } else {
                //其他H5
                param.positionCode = `${taoShaMXX}.index.icon`;
            }
            GetSever('//v-z.jd.com/component/standardInfo.action', param).then(resData => {
                if (resData && resData.data && resData.data.slotVoList && resData.data.slotVoList.length) {
                    const _slotVoList = resData.data.slotVoList;
                    if (_slotVoList.length < 5) {
                        this.IconList = [];
                        this.IconListLength = 0;
                    } else if (_slotVoList.length >= 5 && _slotVoList.length < 10) {
                        this.IconList = _slotVoList.splice(0, 5);
                        this.IconListLength = 5;
                    } else if (_slotVoList.length >= 10) {
                        let _list = _slotVoList.splice(0, 10);
                        this.IconList = this._arrSplit(_list, 5);
                        this.IconListLength = 10;
                    }
                }
            });
        },
        //二维数组
        _arrSplit(arr, n) {
            const result = [];
            if (arr && arr.length) {
                for (let i = 0; i < arr.length; i += n) {
                    result.push(arr.slice(i, i + n));
                }
                return result;
            }
        },
        //轮播上报数据
        silderUpData(item) {
            if (item.clickurl && JSON.parse(item.clickurl)) {
                const _clickUrlList = JSON.parse(item.clickurl);
                if (_clickUrlList && _clickUrlList.length) {
                    _clickUrlList.map(el => {
                        let newImg = document.createElement('img');
                        newImg.src = el;
                        newImg.className = 'clickLaikeData';
                        newImg.style.display = 'none';
                        document.getElementById('clickLaiKeData').appendChild(newImg);
                        setTimeout(() => {
                            const clickImg = document.getElementById('clickLaiKeData').getElementsByClassName('clickLaikeData').length;
                            window.location.href = item.url || '';
                            if (clickImg && clickImg > 0) {
                                document.getElementById('clickLaiKeData').innerHTML = '';
                            }
                        }, 300);
                    });
                }
            } else {
                window.location.href = item.url || '';
            }
            // try {
            //     if (item && item.clickurl && item.clickurl.length) {
            //         item.clickUrlList.forEach(list => {
            //             $.ajax({
            //                 url: list,
            //                 success: () => {}
            //             });
            //         });
            //     }
            // } catch (error) {}
        },
        //banner上报数据
        bannerUpData(item) {
            // try {
            //     if (item && item.clickUrlList && item.clickUrlList.length) {
            //         item.clickUrlList.forEach(list => {
            //             $.ajax({
            //                 url: list,
            //                 success: () => {}
            //             });
            //         });
            //     }
            // } catch (error) {}
        },
        onScrollEnd(index) {
            this.newUrl = this.newList[index].url;
            this.newHomeBg = this.newList[index].image;
            this.title = this.newList[index].title || '';
            this.newIndex = index;
            // this.showBgBanner = false;
            // this.$nextTick(() => {
            //     this.showBgBanner = true;
            // });
            this.newBannerUpdata = this.newList[index];
            this.exposureLaikeData(index);
        },
        showRedTip(item) {
            if (item.labeldes == '免息红包') {
                if (this.isDue) {
                    this.isDue = false;
                    setTimeOverdue('everyday_red');
                }
            } else {
                console.log('item');
            }
        },
        //首页banner接来客
        // getSelectedActivity() {
        //     const defer = window.jsBridgeV3.onReady();
        //     const selectedActivity = {};
        //     defer.then(res => {
        //         res.jsToGetResp(
        //             d => {
        //                 d = typeof d == 'object' ? d : JSON.parse(d);
        //                 if (d.deviceInfo) {
        //                     selectedActivity.userAgent = $.device.jdPayClientName; //用户的浏览器类型，即HTTP请求头部的User-Agent
        //                     selectedActivity.language = ''; //用户的默认系统语言
        //                     selectedActivity.os = $.device.os ? $.device.os : ''; //操作系统
        //                     selectedActivity.osv = $.device.osVersion ? $.device.osVersion : ''; //系统版本
        //                     selectedActivity.orientation = 3; //用户设备的屏幕方向 1：竖屏； 2：横屏； 3：未知
        //                     selectedActivity.brand = d.deviceInfo.clientType ? d.deviceInfo.clientType : ''; //硬件品牌
        //                     selectedActivity.hwv = d.deviceInfo.osPlatform ? d.deviceInfo.osPlatform : ''; //设备硬件版本
        //                     selectedActivity.operator = 0; //设备的网络运营商
        //                     selectedActivity.network = 0; //0-未识别，1-wifi，2-2g，3-3g，4-4g
        //                     selectedActivity.h = window.screen.height; //屏幕高度
        //                     selectedActivity.w = window.screen.width; //屏幕宽度
        //                     selectedActivity.deviceSize = $.device.screen ? $.device.screen : ''; //屏幕分辨率
        //                     selectedActivity.lon = d.deviceInfo.longitude ? d.deviceInfo.longitude : ''; //经度
        //                     selectedActivity.lat = d.deviceInfo.latitude ? d.deviceInfo.latitude : ''; //纬度
        //                     selectedActivity.mac = $.device.mac ? $.device.mac : ''; //用户设备的mac地址
        //                     selectedActivity.locationInfo = d.deviceInfo.city ? d.deviceInfo.city : ''; //位置信息
        //                     if ($.device.clientType === 'android') {
        //                         selectedActivity.androidId = d.deviceInfo.UUID ? d.deviceInfo.UUID : ''; //对于安卓设备设置安卓id。ios不填
        //                         selectedActivity.deviceId = d.deviceInfo.deviceId ? d.deviceInfo.deviceId : ''; //用户设备唯一标识 ，ios-idfa，安卓-imei
        //                         selectedActivity.ip = d.deviceInfo.IPAddress1 ? d.deviceInfo.IPAddress1 : '';
        //                     }
        //                     if ($.device.clientType === 'ios') {
        //                         selectedActivity.deviceId = d.deviceInfo.IDFA ? d.deviceInfo.IDFA : '';
        //                         selectedActivity.ip = '10.13.61.73';
        //                     }
        //                     if (d.terminalType) {
        //                         //设备平台（ e.g., " 0手机 ，1平板 ，3电视 "）
        //                         selectedActivity.deviceType = d.deviceInfo.terminalType.substr(1);
        //                     } else {
        //                         selectedActivity.deviceType = '';
        //                     }
        //                     request.selectedActivity({
        //                         data: {
        //                             userDeviceInfo: selectedActivity
        //                         },
        //                         success: rstData => {
        //                             this.$loading.hide();
        //                             if (rstData && rstData.bannerList && rstData.bannerList.length) {
        //                                 let _item = rstData.bannerList[0];
        //                                 // this.list.splice(this.list.length, 1, _item);
        //                                 this.list.splice(3, 0, _item);
        //                                 this.$set(this, 'list', this.list);
        //                                 this.$refs.mychild.update();
        //                                 if (_item.showUrlList && _item.showUrlList.length) {
        //                                     try {
        //                                         _item.showUrlList.forEach(list => {
        //                                             $.ajax({
        //                                                 url: list,
        //                                                 success: () => {}
        //                                             });
        //                                         });
        //                                     } catch (error) {
        //                                         console.log(error);
        //                                     }
        //                                 }
        //                             }
        //                         },
        //                         afterError: res => {
        //                             console.log(res);
        //                             this.$loading.hide();
        //                         }
        //                     });
        //                 }
        //             },
        //             {
        //                 type: 9,
        //                 //isLocation—是否要获取定位信息,原生默认为true
        //                 isLocation: true,
        //                 data: ''
        //             }
        //         );
        //     });
        // },
        //曝光来客数据
        exposureLaikeData(index) {
            if (this.newList && this.newList.length && this.newList[index]) {
                const _showUrl = this.newList[index].showurl;
                const currenView = document.getElementsByClassName('slider-group')[0].getElementsByClassName('slider-item')[index];
                const hasexposureDom = currenView.getElementsByClassName('exposureLaikeData').length;
                if (hasexposureDom && hasexposureDom.length != 0) {
                    // console.log(currenView, 'currenViewcurrenView存在');
                } else {
                    if (_showUrl && JSON.parse(_showUrl)) {
                        const _showUrllist = JSON.parse(_showUrl);
                        if (_showUrllist && _showUrllist.length) {
                            try {
                                _showUrllist.map(list => {
                                    let newImg = document.createElement('img');
                                    newImg.src = list;
                                    newImg.className = 'exposureLaikeData';
                                    newImg.style.display = 'none';
                                    currenView.appendChild(newImg);
                                });
                                // console.log(currenView, 'currenViewcurrenView不存在');
                            } catch (error) {
                                console.log(error);
                            }
                        }
                    }
                }
            }
        },
        //获取banner背景图活动信息
        bannerBgInfor() {
            const param = {
                positionCode: bannerBgPositionCode
            };
            GetSever('//v-z.jd.com/component/standardInfo.action', param).then(res => {
                if (res && !isEmptyObj(res)) {
                    const { data } = res;
                    if (data && !isEmptyObj(data)) {
                        const { propertyList, slotVoList } = data;
                        if (propertyList && propertyList.length) {
                            propertyList.map(item => {
                                this.bannerBgColor = item.bgcolor;
                            });
                        } else {
                            this.bannerBgColor = '#000';
                        }
                        if (slotVoList && slotVoList.length) {
                            slotVoList.map(ele => {
                                if (ele && !isEmptyObj(ele) && ele.image) {
                                    this.isOpenActivity = true;
                                    this.ActivityBannerObj = ele;
                                } else {
                                    this.isOpenActivity = false;
                                    this.ActivityBannerObj = {};
                                }
                            });
                        } else {
                            this.isOpenActivity = false;
                            this.ActivityBannerObj = {};
                        }
                    }
                }
            });
        },
        //获取首页小banner数组
        // getbannerList() {
        //     if ($.device && $.device.jdjr && window.JrBridge) {
        //         const selectedActivity = {};
        //         window.JrBridge.getDeviceInfo(data => {
        //             if (this.newList && !this.newList.length) {
        //                 if (data && !isEmptyObj(data)) {
        //                     const deviceInfo = data.deviceInfo;
        //                     selectedActivity.userAgent = $.device.jdPayClientName; //用户的浏览器类型，即HTTP请求头部的User-Agent
        //                     selectedActivity.orientation = 3; //用户设备的屏幕方向 1：竖屏； 2：横屏； 3：未知
        //                     selectedActivity.operator = 0; //设备的网络运营商
        //                     selectedActivity.network = 0; //0-未识别，1-wifi，2-2g，3-3g，4-4g
        //                     selectedActivity.h = window.screen.height; //屏幕高度
        //                     selectedActivity.w = window.screen.width; //屏幕宽度
        //                     selectedActivity.device_size = $.device.screen ? $.device.screen : ''; //屏幕分辨率
        //                     if (!isEmptyObj(deviceInfo)) {
        //                         selectedActivity.lon = deviceInfo.longitude ? deviceInfo.longitude : ''; //经度
        //                         selectedActivity.lat = deviceInfo.latitude ? deviceInfo.latitude : ''; //纬度
        //                         selectedActivity.os = deviceInfo.osPlatform ? deviceInfo.osPlatform : ''; //操作系统
        //                         selectedActivity.osv = deviceInfo.osVersion ? deviceInfo.osVersion : ''; //系统版本
        //                         selectedActivity.mac = deviceInfo.macAddress ? deviceInfo.macAddress : ''; //用户设备的mac地址
        //                         selectedActivity.hwv = deviceInfo.osPlatform ? deviceInfo.osPlatform : ''; //设备硬件版本
        //                         selectedActivity.brand = deviceInfo.osPlatform ? deviceInfo.osPlatform : ''; //硬件品牌
        //                         selectedActivity.ip = deviceInfo.IPAddress1 ? deviceInfo.IPAddress1 : '';
        //                         if ($.device.clientType === 'ios') {
        //                             selectedActivity.device_id = deviceInfo.IDFA ? deviceInfo.IDFA : ''; //用户设备唯一标识 ，ios-idfa，安卓-imei
        //                             // selectedActivity.ip = '10.13.61.73';
        //                         }
        //                         if ($.device.clientType === 'android') {
        //                             selectedActivity.android_id = deviceInfo.UUID ? deviceInfo.UUID : ''; //对于安卓设备设置安卓id。ios不填
        //                             selectedActivity.device_id = deviceInfo.deviceId ? deviceInfo.deviceId : ''; //用户设备唯一标识 ，ios-idfa，安卓-imei
        //                             // selectedActivity.ip = deviceInfo.IPAddress1 ? deviceInfo.IPAddress1 : '';
        //                         }
        //                         if (deviceInfo.terminalType) {
        //                             //设备平台（ e.g., " 0手机 ，1平板 ，3电视 "）
        //                             selectedActivity.device_type = deviceInfo.terminalType.substr(1);
        //                         } else {
        //                             selectedActivity.device_type = '';
        //                         }
        //                     }
        //                     this.getLaikeBannerData(selectedActivity);
        //                 } else {
        //                     this.getLaikeBannerData();
        //                 }
        //             }
        //         });
        //     }
        // },

        // 获取设备信息
        getDeviceInfo() {
            // 设备信息对象
            const deviceInfo = {};
            // 缺省处理，当bridge桥异常无法返回设备信息时，设备信息对象为空对象
            const defaultPromise = new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve(deviceInfo);
                    console.log('缺省处理，当bridge桥异常无法返回设备信息时，设备信息对象为空对象');
                }, 650);
            });
            // 正常处理，当bridge桥正常返回设备信息时，设备信息对象有值
            const bridgePromise = new Promise((resolve, reject) => {
                setTimeout(() => {
                    window.JrBridge.callNative(
                        {
                            type: '57'
                        },
                        resultData => {
                            if (typeof resultData == 'object') {
                                // 系统类型: ios || android
                                deviceInfo.os = resultData.os || '';
                                // 系统版本号码
                                deviceInfo.osv = resultData.osv || '';
                                // 手机品牌
                                deviceInfo.brand = resultData.brand || '';
                                // 手机型号
                                deviceInfo.hwv = resultData.hwv || '';
                                // 设备运营商
                                deviceInfo.operator = resultData.imsi ? resultData.imsi.toString().slice(0, 5) : '';
                                // 网络类型
                                deviceInfo.network = resultData.network || 0;
                                // 设备号
                                deviceInfo.device_id = resultData.deviceId || '';
                                // 安卓设备id和mac
                                if ($.device.android) {
                                    deviceInfo.android_id = resultData.androidId ? resultData.androidId.toString() : '';
                                    deviceInfo.mac = resultData.mac || '';
                                } else {
                                    deviceInfo.mac = '02:00:00:00:00';
                                }
                                // useragent
                                deviceInfo.user_agent = window.navigator.userAgent;
                                //屏幕高度
                                deviceInfo.h = window.screen.height;
                                //屏幕宽度
                                deviceInfo.w = window.screen.width;
                                //屏幕高度x宽度
                                deviceInfo.device_size = window.screen.height + 'x' + window.screen.width;
                                // 设备类型
                                if ($.device.ios) {
                                    deviceInfo.device_type = 'iPhone';
                                } else if ($.device.android) {
                                    deviceInfo.device_type = 'android';
                                } else {
                                    deviceInfo.device_type = '';
                                }
                                // 经纬度 传一个缺省值，精准通会校验
                                deviceInfo.lon = '84.344';
                                deviceInfo.lat = '-115.053';
                            }
                            resolve(deviceInfo);
                            console.log('正常处理，当bridge桥正常返回设备信息时，设备信息对象有值');
                        }
                    );
                }, 300);
            });
            const racePromise = Promise.race([defaultPromise, bridgePromise]);
            return racePromise;
        },
        /*
         * 版本号比较方法
         * 传入两个字符串，当前版本号：curV；比较版本号：reqV
         * 调用方法举例：compare("1.1","1.2")，将返回false
         */
        compareVersion(curV, reqV) {
            if (curV === reqV) {
                return true;
            }
            if (curV && reqV) {
                //将两个版本号拆成数字
                var arr1 = curV.split('.'),
                    arr2 = reqV.split('.');
                var minLength = Math.min(arr1.length, arr2.length),
                    position = 0,
                    diff = 0;
                //依次比较版本号每一位大小，当对比得出结果后跳出循环（后文有简单介绍）
                while (position < minLength && (diff = parseInt(arr1[position]) - parseInt(arr2[position])) == 0) {
                    position++;
                }
                diff = diff != 0 ? diff : arr1.length - arr2.length;
                //若curV大于reqV，则返回true
                return diff > 0;
            } else {
                //输入为空
                // console.log("版本号不能为空");
                return false;
            }
        },
        getbannerList() {
            if ($.device && $.device.jdjr && window.JrBridge && this.compareVersion($.device.clientVersion, '5.2.70')) {
                // jrapp环境 && JrBridge桥已初始化 && jrapp版本大于等于5.2.70 ->获取来客数据
                console.log('jrapp版本号大于或等于5.2.70');
                this.getDeviceInfo().then(deviceInfo => {
                    this.getLaikeBannerData(deviceInfo);
                });
            } else {
                // 非jrapp环境 || jrapp版本小于5.2.70 获取兜底数据
                console.log('jrapp版本号小于5.2.70或非jrapp环境');
                this.getLaikeBannerData({});
            }
        },

        getLaikeBannerData(param) {
            let partParam = {
                positionCode: smallBannerPositionCode
            };
            if (param && !isEmptyObj(param)) {
                partParam = Object.assign({}, partParam, param);
            }
            GetSever('//v-z.jd.com/component/standardInfo.action', partParam).then(res => {
                this.$emit('onloadBannerFresh');
                if (res && !isEmptyObj(res)) {
                    const { data } = res;
                    if (data && !isEmptyObj(data)) {
                        const { slotVoList } = data;
                        if (slotVoList && slotVoList.length) {
                            this.newList = slotVoList;
                            // slotVoList.map(item => {
                            //     if (item.showurl && item.showurl.length) {
                            //         try {
                            //             item.showurl.forEach(list => {
                            //                 $.ajax({
                            //                     url: list,
                            //                     success: () => {}
                            //                 });
                            //             });
                            //         } catch (error) {
                            //             console.log(error);
                            //         }
                            //     }
                            // });
                        }
                    }
                    // this.$emit('onloadBannerFresh');
                }
            });
        }
    },
    mounted() {
        this.isDue = isTimeOverdue('everyday_red');
        setTimeout(() => {
            this.HomeBannerHeight = $('.ui-newHome-banner').height();
        }, 400);

        // if ($.device && $.device.jdjr) {
        //     // if (this.hasOpenLaiKe) {
        //     setTimeout(() => {
        //         // this.getSelectedActivity();
        //         this.getbannerList();
        //     }, 300);
        //     // }
        // }
    },
    watch: {
        // 监听数据的变化，延时refreshDelay时间后调用refresh方法重新计算，保证滚动效果正常
        // list: {
        //     handler(val) {
        //         this.newList = val;
        //         setTimeout(() => {
        //             this.$nextTick(() => {
        //                 this.onScrollEnd(0);
        //             });
        //         }, 10);
        //     },
        //     deep: true
        // }
        newList: {
            handler() {
                setTimeout(() => {
                    this.$nextTick(() => {
                        this.onScrollEnd(0);
                    });
                }, 10);
            },
            deep: true
        }
    },

    destroyed() {
        this.$refs = null;
        this._self = null;
        if (settime) {
            window.clearTimeout(settime);
            settime = null;
        }
    }
};
</script>

<style lang="scss">
@import './../scss/mixin.scss';
.store_home_banner {
    min-height: $rem330;
    position: relative;
    margin-bottom: $rem14;
    padding-top: $rem80;
    .store_banner_ActivityBg {
        width: 100%;
        height: auto;
    }
    .store_banner_bg {
        width: 100%;
        height: $rem260;
    }
    .store_banner_slider {
        width: 100%;
        padding-left: $rem32;
        padding-right: $rem32;
        position: absolute;
        left: 0;
        z-index: 100;
        border-radius: $rem16;
        overflow: hidden;
    }
    .store_banner_swiperActivity {
        top: $rem104;
    }
    .store_banner_swiperNo {
        bottom: -$rem10;
    }
}

.ui-newHome-banner {
    // padding-bottom: $rem20;
    background: #fff;
    .newHome-bg-content {
        // min-height: 300px;
        min-height: $rem538;
        // height: $rem287;
        overflow: hidden;
    }
    .newHome-bg-noActivity {
        // min-height: $rem450;
        min-height: $rem338;
        // min-height: $rem287;
        // height: $rem287;
        overflow: hidden;
    }
    .newHome-bg {
        position: relative;
        height: 100%;
    }

    // .ui-homebg {
    //     background-size: 100% $rem50;
    //     background-image: url('//m.360buyimg.com/jrqb/jfs/t1/4411/17/9022/734/5bab470bE24093fbd/467c6a2650b69ed8.png');
    //     background-position: bottom;
    //     background-repeat: no-repeat;
    //     height: auto;
    // }
    .ui-redtip {
        position: absolute;
        right: $rem10;
        top: $rem8;
        background: #ee3d51;
        border-radius: 50%;
        width: $rem20;
        height: $rem20;
    }
    // .ui-home-f {
    //     background-position: bottom;
    //     padding: 0 $rem42 $rem57 $rem42;
    //     width: 100%;
    // }
    .act-slide1 {
        height: auto !important;
        top: $rem36;
        a {
            height: 100%;
            img {
                width: 100%;
                background: #cad3e4;
                box-shadow: 0 10px 20px 0 rgba(11, 19, 43, 0.24);
            }
        }
    }
    .ui-home-banner {
        width: 100%;
        display: flex;
        // height: $rem190;
        background: #ffffff;
        font-size: $rem24;
        color: #333333;
        text-align: center;
        // padding: $rem30 $rem16 $rem50 $rem16;
        padding: $rem30 $rem35 $rem50 $rem35;
    }
    .ui-flex {
        flex: 1;
        img {
            width: $rem80;
            height: $rem80;
        }
    }
    .act-banner1 {
        // height: 100%;
        width: 100%;
        border-radius: $rem8;
    }
    .act-banner1-wrap {
        border-radius: $rem8;
        position: relative;
    }
    .store_banner_swiper_adv {
        position: absolute;
        width: $rem72;
        height: $rem72;
        position: absolute;
        right: $rem44;
        bottom: $rem12;
    }
    .ui-kpl {
        // box-shadow: 0 4px 3px 0 rgba(11,19,43,0.1);
    }

    .ui-kpl-bg {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
    }
    .ui-banner {
        width: 100%;
        // min-height: 264px;
        position: absolute;
        bottom: -1px;
        z-index: 9;
    }
    .ui-bannerNoActivity {
        width: 100%;
        bottom: -1px;
        z-index: 9;
    }

    .ui-text {
        padding-top: $rem10;
        font-size: $rem26;
        color: #333333;
        font-family: PingFangSC-Regular;
    }
    .newhome-img {
        width: 100%;
    }
    .newhome-img-hidden {
        width: 100%;
        visibility: hidden;
    }
    .ui-newHomeNum {
        top: 2rem;
        right: 1rem;
        z-index: 9999;
        color: #ffffff;
        // color: red;
        text-align: right;
        position: relative;
    }
    .ui-newHomeIndex {
        font-size: $rem40;
    }
    .ui-newHomeSum {
        font-size: $rem26;
    }
    .ui-newHomeLine {
        font-size: $rem35;
    }

    .bannerFadeIn-enter-active {
        transition-timing-function: ease-in;
        transition: opacity 0.3s;
    }

    .bannerFadeIn-enter {
        opacity: 0;
    }
}

@media screen and (min-width: 330px) and (max-width: 400px) {
    .ui-newHome-banner {
        // .newHome-bg-content {
        //   // min-height: 370px;
        //   // min-height: 287px;
        // }
    }
}
.marTop {
    height: $rem60;
}
.redPackWrap {
    width: 2.5rem;
    height: 2.5rem;
    margin: 0 auto;
    position: relative;
}

.icon_wrap {
    padding: $rem30 $rem35 $rem0 $rem35;
    background: #fff;
}
.ui-home-banner10 {
    width: 100%;
    display: flex;
    font-size: $rem24;
    color: #333333;
    text-align: center;
    padding-bottom: $rem50;
}
</style>
